"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardPreview = CardPreview;
var _react = _interopRequireDefault(require("react"));
var _elements = require("@reservamos/elements");
var _reactI18next = require("react-i18next");
var _cardGradient = require("@/components/purchase/BasisTheoryCheckout/cardGradient");
/** Render the card selected for the installment plan. */
function CardPreview(_ref) {
  var _preview$cardType, _preview$brand, _preview$cardType2, _preview$brand2, _preview$brand3;
  var preview = _ref.preview;
  var _useTranslation = (0, _reactI18next.useTranslation)('payment'),
    t = _useTranslation.t;
  var maskedNumber = preview !== null && preview !== void 0 && preview.last4 ? "\u2022\u2022\u2022\u2022 ".concat(preview.last4) : '••••';
  var cardType = t("saved_card.type_".concat((_preview$cardType = preview === null || preview === void 0 ? void 0 : preview.cardType) !== null && _preview$cardType !== void 0 ? _preview$cardType : 'credit'));
  var brandLabel = (0, _cardGradient.getCardBrandLabel)((_preview$brand = preview === null || preview === void 0 ? void 0 : preview.brand) !== null && _preview$brand !== void 0 ? _preview$brand : '');
  var cardLabel = preview !== null && preview !== void 0 && preview.brand ? t('saved_card.title', {
    brand: brandLabel,
    type: cardType
  }) : cardType;
  var gradient = (0, _cardGradient.getCardGradient)((_preview$cardType2 = preview === null || preview === void 0 ? void 0 : preview.cardType) !== null && _preview$cardType2 !== void 0 ? _preview$cardType2 : 'credit', (_preview$brand2 = preview === null || preview === void 0 ? void 0 : preview.brand) !== null && _preview$brand2 !== void 0 ? _preview$brand2 : '');
  var cardBrand = (0, _cardGradient.normalizeCardBrand)((_preview$brand3 = preview === null || preview === void 0 ? void 0 : preview.brand) !== null && _preview$brand3 !== void 0 ? _preview$brand3 : '');
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "min-h-[74px] overflow-hidden rounded-xl border border-success-regular bg-success-regular/10 transition-all duration-500 ease-out hover:shadow-md",
    "data-sentry-component": "CardPreview",
    "data-sentry-source-file": "CardPreview.tsx"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex w-full items-center rounded-xl pl-2 shadow-md transition-[padding] duration-500 ease-out md:shadow-none"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex w-12 flex-shrink-0 items-center justify-center",
    "aria-hidden": "true"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex scale-[0.84] items-center justify-center"
  }, /*#__PURE__*/_react["default"].createElement(_elements.Icon, {
    type: "Success",
    color: "success",
    size: "M",
    "data-sentry-element": "Icon",
    "data-sentry-source-file": "CardPreview.tsx"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex min-h-16 flex-1 items-center justify-between rounded-xl px-2 py-4 shadow-sm md:px-5 ".concat(gradient)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex min-w-0 flex-1 items-center gap-1 md:gap-2"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-white p-2"
  }, /*#__PURE__*/_react["default"].createElement(_elements.CreditCardIcon, {
    cardBrand: cardBrand,
    hasMargin: false,
    hideBorder: true,
    "data-sentry-element": "CreditCardIcon",
    "data-sentry-source-file": "CardPreview.tsx"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "min-w-0 flex-1"
  }, /*#__PURE__*/_react["default"].createElement(_elements.Text, {
    size: "S",
    color: "white",
    weight: "bold",
    mobileSize: "XS",
    maxWidthEllipsis: 150,
    mobileMaxWidthEllipsis: 100,
    "data-sentry-element": "Text",
    "data-sentry-source-file": "CardPreview.tsx"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "capitalize"
  }, cardLabel)), /*#__PURE__*/_react["default"].createElement(_elements.Text, {
    size: "S",
    color: "white",
    mobileSize: "XS",
    "data-sentry-element": "Text",
    "data-sentry-source-file": "CardPreview.tsx"
  }, maskedNumber))), (preview === null || preview === void 0 ? void 0 : preview.expirationDate) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "ml-2 flex-shrink-0 text-right"
  }, /*#__PURE__*/_react["default"].createElement(_elements.Text, {
    size: "XS",
    color: "white",
    mobileSize: "XXS"
  }, preview.expirationDate)))));
}